import * as React from 'react';
import { Money, TravelersById } from '../types';
import {
	CheckoutOrderFragment,
	OrderAdditionalServiceGdsServiceServiceType,
	FlightFragment,
	IncludedGdsServicesFragment,
	PassengerSelectedGdsServicesFragment,
	PassengerFragment,
	OrderPriceFragment,
	NASProductCategory
} from '@websky/graphql';
import { ServiceSummaryType } from '../ServiceSummary/types';
import { CheckoutSteps } from '../MobileStepbar/types';
import { Step } from '../BaseComponents/Stepbar/types';

export enum CartService {
	Flights,
	Seats,
	Baggage,
	Meal,
	Passengers,
	Extra,
	Aeroexpress,
	BusinessLounge,
	Insurances,
	SMS,
	Misc,
	Transfer
}

export interface CartServiceFlightSegment {
	segmentId: string;
}

export interface CartServiceInsurance {
	code: string;
}

export interface CartServiceAeroexpress {
	tripId: string;
}

export interface CartServiceGds {
	type: OrderAdditionalServiceGdsServiceServiceType;
	serviceId: string;
	segmentId?: string;
	allowedSegments?: string[][];
	allSegments?: boolean;
	passengerId?: string;
	count?: number;
}

export interface CartServiceProps {
	activeStep?: number;
	steps?: Step[];
	flight: FlightFragment;
	travellers: PassengerFragment[];
	services: CheckoutOrderFragment['additionalServices'];
	hideFlightPrice?: boolean;
	onServiceDelete?: OnDeleteItemType;
	showPassengers?: boolean;
	separateInsurance?: boolean;
	separateAnimals?: boolean;
	customer?: CheckoutOrderFragment['customer'];
	renderService?: (type: CheckoutSteps, group: ServiceSummaryType, content: React.ReactNode) => JSX.Element;
}

export type CartServicePayload =
	| CartServiceFlightSegment
	| CartServiceGds
	| CartServiceInsurance
	| CartServiceAeroexpress;

export type OnDeleteItemType = (type: CartService, service: CartServicePayload) => void;

export interface CartSegment {
	id: string;
	iataDirection: string;
}

export interface CartContext {
	travellersById: TravelersById;
	segmentsById: Map<string, CartSegment>;
	totalPrices: {
		seats?: Money;
		baggage?: Money;
		meal?: Money;
		flights?: Money;
		total?: Money;
		aeroexpress?: Money;
		insurance?: Money;
		businessLounge?: Money;
		animals?: Money;
		transfer?: Money;
		priorityBoarding?: Money;
		refundableTicket?: Money;
		baggageDelivery?: Money;
		sms?: Money;
		nas?: Money;
	};
}

export interface CartPrices extends OrderPriceFragment {
	baggageDelivery?: Money;
	animals?: Money;
	transfer?: Money;
	priorityBoarding?: Money;
	refundableTicket?: Money;
	upgrade?: Money;
	sms?: Money;
}

export type TravellerService = IncludedGdsServicesFragment | PassengerSelectedGdsServicesFragment;

export type CartNasSelectedTraveller = {
	travellerName: string;
	travellerId: string;
	totalPrice: Money;
	canBeDeleted?: boolean;
	category: NASProductCategory;
	name: string;
	date: Date;
	segmentIata: string;
	productId: string;
};

export type NasGroupedServicesByCategory = {
	category: NASProductCategory;
	travellers: CartNasSelectedTraveller[];
};
